import { useEffect } from "react";
import { useDispatch } from "react-redux";

import ConnectedIntlProvider from "./components/ConnectedIntlProvider.jsx";
import Routes from "./routes/Routes.jsx";
import { resume } from "./store/thunks.js";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Only resume if we're not on the login/logout page.
    if (location.pathname !== "/login" && location.pathname !== "/logout") {
      dispatch(resume());
    }
  }, [dispatch, location.pathname]);

  return (
    <ConnectedIntlProvider>
      <Routes />
    </ConnectedIntlProvider>
  );
}

export default App;
